// extracted by mini-css-extract-plugin
module.exports = {"Links":"Links_Links__1hP03","Link":"Links_Link__J40-b","LinkTitle":"Links_LinkTitle__3zxsN"};